import {Box, Tabs, Tab} from "@mui/material";
import * as React from 'react';
import TabPanel from "../../../../share/components/tab/TabPanel";
import { Cutting } from "../../../types/models/Cutting";
import TimberStorageListItem from "../../../../timber/components/timberStorage/TimberStorageList/TimberStorageListItem";
import ShipmentListItem from "../../../../timber/components/shipment/ShipmentList/ShipmentListItem";
import LogListItem from "../../../../timber/components/log/LogList/LogListItem";
import CordwoodListItem from "../../../../timber/components/cordwood/CordwoodList/CordwoodListItem";
import TreeMarkingListItem from "../../../../timber/components/treeMarking/TreeMarkingList/TreeMarkingListItem";
import {useStateSession} from "../../../../hooks/useAuth";
import { t } from "@lingui/core/macro";
import GenericRootReport, {defaultFormOptions} from "../../generic/report/GenericRootReport.tsx";
import {toString} from "../../../types/models/Cutting.ts";
import ReportTreeMarkings from "../../generic/treeMarkings/ReportTreeMarkings.tsx";
import PriceCalculator from "../../generic/priceCalculator/PriceCalculator.tsx";
import TimelineRootReport from "../../generic/report/TimelineRootReport.tsx";

type IFormProps = {
    data: Cutting;
};

const CuttingTabs: React.FC<IFormProps> = ({ data = {} }) => {

    const session = useStateSession()
    const searchParams = new URLSearchParams(window.location.search)

    const [tabValue, setTabValue] = React.useState(searchParams.get('tab') || 'timberStorage');
    const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
        
        if (searchParams.has('tab')) {
            searchParams.set('tab', newValue)
        } else {
            searchParams.append('tab', newValue)
        }
        window.history.pushState({}, '', '?' + searchParams.toString())

        setTabValue(newValue);
    };

    const customizeFiler = (filter: Record<string, string>): Record<string, string> =>  { return {
        ...filter,
        cuttingId: [data.id],
    }}
    const reportTitle = `Cutting ${toString(data)}`
    const formOptions = {
        ...defaultFormOptions,
        showCutting: false,
    }

    return (
        <Box sx={ { width: '100%' } }>
            <Tabs
                value={tabValue}
                onChange={handleTabChange}
                variant="scrollable"
                scrollButtons="auto"
                data-testid="Cutting-tabs"
            >
                { session.hasPermission('', 'applications/timber/entities/TimberStorages/list/view') &&
                    <Tab label={t`Timber Storages`} value="timberStorage"/>
                }
                { session.hasPermission('', 'applications/timber/entities/Shipments/list/view') &&
                    <Tab label={t`Shipments`} value="shipment"/>
                }
                { session.hasPermission('', 'applications/timber/entities/Logs/list/view') &&
                    <Tab label={t`Logs`} value="log"/>
                }
                { session.hasPermission('', 'applications/timber/entities/Cordwoods/list/view') &&
                    <Tab label={t`Cordwoods`} value="cordwood"/>
                }
                { session.hasPermission('', 'applications/timber/entities/TreeMarkings/list/view') &&
                    <Tab label={t`Tree Markings`} value="treeMarking"/>
                }
                { session.hasPermission('', 'applications/timber/entities/Cuttings/report/view') &&
                    <Tab label={t`Report All`} value="reportAll"/>
                }
                { session.hasPermission('', 'applications/timber/entities/Cuttings/report/view') &&
                    <Tab label={t`Report Not shipt`} value="reportNotShipt"/>
                }
                { session.hasPermission('', 'applications/timber/entities/Cuttings/report/view') &&
                    <Tab label={t`Report Shipt`} value="reportShipt"/>
                }
                { session.hasPermission('', 'applications/timber/entities/PricingProfiles/view') &&
                    <Tab label={t`Price Calculator`} value="priceCalculatorReport"/>
                }
                { session.hasPermission('', 'applications/timber/entities/TreeMarkings/report/view') &&
                    <Tab label={t`Tree Marking Report`} value="treeMarkingsReport"/>
                }
                { session.hasPermission('', 'applications/timber/entities/Cuttings/report/view') &&
                    <Tab label={t`Timeline Report`} value="timelineReport"/>
                }
                </Tabs>
            
            { session.hasPermission('', 'applications/timber/entities/TimberStorages/list/view') &&
                <TabPanel value={tabValue} index="timberStorage" data-testid="TimberStorage-tab">
                    <TimberStorageListItem cuttingId={data?.id} showAdd={ true } />
                </TabPanel>
            }
            { session.hasPermission('', 'applications/timber/entities/Shipments/list/view') &&
                <TabPanel value={tabValue} index="shipment" data-testid="Shipment-tab">
                    <ShipmentListItem cuttingId={data?.id} showAdd={ false } />
                </TabPanel>
            }
            { session.hasPermission('', 'applications/timber/entities/Logs/list/view') &&
                <TabPanel value={tabValue} index="log" data-testid="Log-tab">
                    <LogListItem cuttingId={data?.id} showAdd={ false } />
                </TabPanel>
            }
            { session.hasPermission('', 'applications/timber/entities/Cordwoods/list/view') &&
                <TabPanel value={tabValue} index="cordwood" data-testid="Cordwood-tab">
                    <CordwoodListItem cuttingId={data?.id} showAdd={ false } />
                </TabPanel>
            }
            { session.hasPermission('', 'applications/timber/entities/TreeMarkings/list/view') &&
                <TabPanel value={tabValue} index="treeMarking" data-testid="TreeMarking-tab">
                    <TreeMarkingListItem cuttingId={data?.id} showAdd={ false } />
                </TabPanel>
            }
            { session.hasPermission('', 'applications/timber/entities/Cuttings/report/view') &&
                <TabPanel value={tabValue} index="reportAll">
                    <GenericRootReport
                        shipmentDefined={null}
                        mainTitle={reportTitle}
                        customizeFiler={customizeFiler}
                        formOptions={formOptions}
                    />
                </TabPanel>
            }
            { session.hasPermission('', 'applications/timber/entities/Cuttings/report/view') &&
                <TabPanel value={tabValue} index="reportNotShipt">
                    <GenericRootReport
                        shipmentDefined={false}
                        mainTitle={reportTitle}
                        customizeFiler={customizeFiler}
                        formOptions={formOptions}
                    />
                </TabPanel>
            }
            { session.hasPermission('', 'applications/timber/entities/Cuttings/report/view') &&
                <TabPanel value={tabValue} index="reportShipt">
                    <GenericRootReport
                        shipmentDefined={true}
                        mainTitle={reportTitle}
                        customizeFiler={customizeFiler}
                        formOptions={formOptions}
                    />
                </TabPanel>
            }
            { session.hasPermission('', 'applications/timber/entities/PricingProfiles/view') &&
                <TabPanel value={tabValue} index="priceCalculatorReport">
                    <PriceCalculator
                        shipmentDefined={null}
                        customizeFiler={customizeFiler}
                        formOptions={formOptions}
                    />
                </TabPanel>
            }
            { session.hasPermission('', 'applications/timber/entities/TreeMarkings/report/view') &&
                <TabPanel value={tabValue} index="treeMarkingsReport">
                    <ReportTreeMarkings
                        showStorage={true}
                        cuttingId={[data.id]}
                    />
                </TabPanel>
            }
            { session.hasPermission('', 'applications/timber/entities/Cuttings/report/view') &&
                <TabPanel value={tabValue} index="timelineReport">
                    <TimelineRootReport
                        filter={{ cuttingId: [data.id] }}
                        showCutting={false}
                    />
                </TabPanel>
            }
            
        </Box>
    )
}

export default CuttingTabs;
